export class DocumentUploadModel {
    public documentUploadUrl: string;
    public blobStagingId: number;
    public fileName: string;
}
